import { lengthRequired } from '@polvo-labs/form-utils'
import Password from '../../components/Form/Fields/Password'
import FieldType from '../../components/Form/Fields/type'
import match from '../../components/Form/utils/match'

export interface ChangePasswordFormData {
  current_password: string
  new_password: string
  new_password_confirmation: string
}

export type ChangePasswordForm = keyof ChangePasswordFormData

const fields: FieldType<ChangePasswordForm>[] = [
  {
    name: 'current_password',
    component: Password,
    data: {
      icon: 'password',
      label: '',
    },
    html: {
      placeholder: 'Digite sua senha atual',
    },
    validation: lengthRequired({ min: 6, max: 255 }),
  },
  {
    name: 'new_password',
    component: Password,
    data: {
      icon: 'password',
      label: '',
    },
    html: {
      placeholder: 'Digite sua nova senha',
    },
  },
  {
    name: 'new_password_confirmation',
    component: Password,
    data: {
      icon: 'password',
      label: '',
    },
    html: {
      placeholder: 'Digite sua nova senha novamente',
    },
    validation: {
      validate: match<ChangePasswordFormData>('new_password', 'Senhas não batem'),
    },
  },
]

export default fields
